module.exports = __webpack_public_path__ + "img/motivation-image.2b9fc2ac.svg";